import { Volume2, VolumeX } from "lucide-react";
import { useSoundToggle } from "@/lib/sound";

// One shared scan-sound control. Backed by a single global persisted preference,
// so muting on any scan page mutes everywhere (staff learn one control).
export function SoundToggle({ className = "" }) {
  const [on, toggle] = useSoundToggle();
  return (
    <button
      type="button"
      data-testid="sound-toggle"
      onClick={toggle}
      title={on ? "Scan sounds on — tap to mute everywhere" : "Muted — tap to enable scan sounds everywhere"}
      className={`inline-flex items-center gap-1.5 text-xs font-mono border border-slate-200 px-3 py-2 rounded-lg hover:border-slate-400 shrink-0 ${className}`}
    >
      {on ? <Volume2 className="w-4 h-4 text-emerald-600" /> : <VolumeX className="w-4 h-4 text-slate-400" />}
      {on ? "SOUND ON" : "MUTED"}
    </button>
  );
}
